export default {"src":"/_next/static/media/popcornseasoning.022da585.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};